(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clothing-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-cc-desc-toggle]');
    if (!toggle) return;
    var wrapper = toggle.closest('[data-cc-desc]');
    if (!wrapper) return;
    var expanded = wrapper.classList.toggle('is-expanded');
    toggle.textContent = expanded ? 'Read Less' : 'Read More';
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-section-type="clothing-collection"]').forEach(initClothingCollection);
  });

  function initClothingCollection(root) {
    if (root.dataset.ccInit === 'true') return;
    root.dataset.ccInit = 'true';

    if (window.RfrInfiniteScroll) {
      window.RfrInfiniteScroll.init({
        root: root,
        gridSelector: '[data-product-grid]',
        itemSelector: '.cc-grid__item',
        paginationSelector: '.cc-pagination'
      });
    }

    var sectionId = root.dataset.sectionId;
    var scrim = root.querySelector('[data-panel-scrim]');

    function closeAllPanels() {
      root.querySelectorAll('[data-panel-body]').forEach(function (panel) {
        panel.classList.remove('is-open');
      });
      if (scrim) {
        scrim.classList.remove('is-open');
        scrim.hidden = true;
      }
    }

    function openPanel(name) {
      var panel = root.querySelector('[data-panel-body="' + name + '"]');
      if (!panel) return;
      closeAllPanels();
      panel.classList.add('is-open');
      if (window.matchMedia('(max-width: 900px)').matches && scrim) {
        scrim.hidden = false;
        requestAnimationFrame(function () {
          scrim.classList.add('is-open');
        });
      }
    }

    root.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-panel-trigger]');
      if (trigger) {
        var name = trigger.dataset.panelTrigger;
        var panel = root.querySelector('[data-panel-body="' + name + '"]');
        if (panel && panel.classList.contains('is-open')) {
          closeAllPanels();
        } else {
          openPanel(name);
        }
        return;
      }

      if (e.target.closest('[data-panel-close]')) {
        closeAllPanels();
        return;
      }

      var clearBtn = e.target.closest('[data-clear-all]');
      if (clearBtn) {
        e.preventDefault();
        resetExtraFilters();
        fetchAndApply(root.dataset.collectionUrl);
        return;
      }

      var chip = e.target.closest('[data-filter-link]');
      if (chip) {
        e.preventDefault();
        fetchAndApply(chip.getAttribute('href'));
        return;
      }

      var midTabBtn = e.target.closest('[data-mid-tab]');
      if (midTabBtn) {
        var midFilter = midTabBtn.closest('[data-mid-filter]');
        if (midFilter) {
          var targetKind = midTabBtn.dataset.midTab;
          midFilter.querySelectorAll('[data-mid-tab]').forEach(function (btn) {
            var isTarget = btn === midTabBtn;
            btn.classList.toggle('is-active', isTarget);
            btn.setAttribute('aria-selected', isTarget ? 'true' : 'false');
          });
          midFilter.querySelectorAll('[data-mid-pane]').forEach(function (pane) {
            pane.hidden = pane.dataset.midPane !== targetKind;
          });
        }
        return;
      }

      var midApply = e.target.closest('[data-mid-filter-apply]');
      if (midApply) {
        var grid = root.querySelector('[data-product-grid]');
        if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    });

    if (scrim) {
      scrim.addEventListener('click', closeAllPanels);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllPanels();
    });

    document.addEventListener('click', function (e) {
      var sortWrap = root.querySelector('[data-panel-wrap="sort"]');
      var sortPanel = root.querySelector('[data-panel-body="sort"]');
      if (
        sortWrap &&
        sortPanel &&
        sortPanel.classList.contains('is-open') &&
        !sortWrap.contains(e.target) &&
        window.matchMedia('(min-width: 901px)').matches
      ) {
        closeAllPanels();
      }
    });

    var filterForm = root.querySelector('[data-filter-form]');
    if (filterForm) {
      filterForm.addEventListener('change', function (e) {
        if (!e.target.matches('[data-filter-input]')) return;
        var params = new URLSearchParams(new FormData(filterForm));
        var sortInput = root.querySelector('[data-sort-input]:checked');
        if (sortInput) params.set('sort_by', sortInput.value);
        var url = root.dataset.collectionUrl + '?' + params.toString();
        fetchAndApply(url);
      });
    }

    root.querySelectorAll('[data-sort-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        var params = new URLSearchParams(filterForm ? new FormData(filterForm) : '');
        params.set('sort_by', input.value);
        var url = root.dataset.collectionUrl + '?' + params.toString();
        fetchAndApply(url, function () {
          closeAllPanels();
        });
      });
    });

    function fetchAndApply(url, done) {
      var sep = url.indexOf('?') > -1 ? '&' : '?';
      fetch(url + sep + 'section_id=' + sectionId)
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          replacePart(doc, '[data-product-grid]');
          replacePart(doc, '[data-filter-form]');
          replacePart(doc, '[data-result-count]');
          replacePart(doc, '[data-filter-item-count]');
          replacePart(doc, '[data-filter-item-count-inline]');
          replaceAllQuickFilters(doc);

          var newClearButtons = doc.querySelectorAll('[data-clear-all]');
          root.querySelectorAll('[data-clear-all]').forEach(function (btn, i) {
            if (newClearButtons[i]) btn.hidden = newClearButtons[i].hidden;
          });

          var newDot = doc.querySelector('[data-filter-dot]');
          var dot = root.querySelector('[data-filter-dot]');
          if (dot && newDot) dot.hidden = newDot.hidden;

          // replacePart('[data-product-grid]') just wiped out the JS-
          // injected infinite-scroll sentinel along with the grid's old
          // contents (it lives inside the grid, right after .cc-pagination)
          // — re-init against the freshly-fetched pagination/grid so
          // scrolling still loads more of *this* filtered result set.
          if (window.RfrInfiniteScroll) {
            window.RfrInfiniteScroll.init({
              root: root,
              gridSelector: '[data-product-grid]',
              itemSelector: '.cc-grid__item',
              paginationSelector: '.cc-pagination'
            });
          }

          history.replaceState({}, '', url);

          // A native filter/sort change just replaced the grid with a fresh
          // (unfiltered-by-extras) page 1, and the dataset any active extra
          // filter was matching against is now stale — drop the cache and,
          // if extra filters are still checked, re-fetch/re-apply them
          // against the new native filter state. Otherwise just remember
          // this as the new "restore to" snapshot.
          invalidateExtraDataset();
          if (extraHasActive()) {
            applyExtraFilters();
          } else {
            captureOriginalGrid();
          }

          if (typeof done === 'function') done();
        })
        .catch(function (err) {
          console.error('Clothing collection filter/sort request failed:', err);
        });
    }

    function replacePart(doc, selector) {
      var current = root.querySelector(selector);
      var next = doc.querySelector(selector);
      if (current && next) current.innerHTML = next.innerHTML;
    }

    // There are now several independent quick-filter rows on the page
    // (toolbar style band, toolbar age band, mid-grid "Filters for you"
    // style/age bands), each tagged data-quick-filter="<kind>". Replace
    // each by its own kind so a filter/sort AJAX refresh keeps every row's
    // active-chip state in sync, not just the first one in DOM order.
    function replaceAllQuickFilters(doc) {
      root.querySelectorAll('[data-quick-filter]').forEach(function (el) {
        var kind = el.getAttribute('data-quick-filter') || '';
        var next = doc.querySelector('[data-quick-filter="' + kind + '"]');
        if (next) el.innerHTML = next.innerHTML;
      });
    }

    /* ---------- extra filters (client-side, beyond Search & Discovery's facet cap) ----------
       Each block under [data-extra-filters] is one facet backed by a
       product metafield (e.g. shopify.neckline) rather than a Search &
       Discovery filter, so there's no limit on how many a merchant adds.
       Because there's no server-side index for these, multi-select (OR
       within a facet, AND across facets) can't be resolved with a server
       round trip the way native filters are — so once any of these is
       checked, we pull every page of the *current* native filter/sort
       result (capped at EXTRA_MAX_PAGES pages) via the same section-render
       fetch already used for pagination, read each card's metafield values
       off its data-cc-facets attribute, and do the OR/AND matching here. */
    var extraFiltersEl = root.querySelector('[data-extra-filters]');
    var EXTRA_MAX_PAGES = 25;
    var extraActive = {};
    var extraCacheKey = null;
    var extraCacheItems = null;
    var extraOriginalGridHTML = null;
    var extraLoadToken = 0;

    function extraGetActiveGroups() {
      return Object.keys(extraActive).filter(function (g) {
        return extraActive[g] && extraActive[g].size > 0;
      });
    }

    function extraHasActive() {
      return extraFiltersEl ? extraGetActiveGroups().length > 0 : false;
    }

    function captureOriginalGrid() {
      if (!extraFiltersEl) return;
      var grid = root.querySelector('[data-product-grid]');
      if (grid) extraOriginalGridHTML = grid.innerHTML;
    }

    function invalidateExtraDataset() {
      extraCacheKey = null;
      extraCacheItems = null;
    }

    function resetExtraFilters() {
      if (!extraFiltersEl) return;
      extraActive = {};
      extraFiltersEl.querySelectorAll('[data-extra-filter-input]').forEach(function (input) {
        input.checked = false;
      });
      invalidateExtraDataset();
    }

    function restoreOriginalGrid() {
      var grid = root.querySelector('[data-product-grid]');
      if (grid && extraOriginalGridHTML !== null) {
        grid.innerHTML = extraOriginalGridHTML;
        if (window.RfrInfiniteScroll) {
          window.RfrInfiniteScroll.init({
            root: root,
            gridSelector: '[data-product-grid]',
            itemSelector: '.cc-grid__item',
            paginationSelector: '.cc-pagination'
          });
        }
      }
    }

    function extraDatasetKey() {
      var u = new URL(window.location.href);
      u.searchParams.delete('page');
      return u.toString();
    }

    function loadExtraDataset(cb) {
      var key = extraDatasetKey();
      if (extraCacheKey === key && extraCacheItems) {
        cb(extraCacheItems);
        return;
      }

      var token = ++extraLoadToken;
      var items = [];

      function fetchPage(page) {
        var u = new URL(key);
        u.searchParams.set('page', page);
        u.searchParams.set('section_id', sectionId);
        fetch(u.toString())
          .then(function (r) { return r.text(); })
          .then(function (html) {
            if (token !== extraLoadToken) return; // superseded by a newer load
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var nodes = doc.querySelectorAll('[data-product-grid] .cc-grid__item[data-cc-facets]');
            if (!nodes.length) {
              finish();
              return;
            }
            nodes.forEach(function (node) {
              var facets = {};
              try {
                facets = JSON.parse(node.getAttribute('data-cc-facets') || '{}');
              } catch (err) {
                facets = {};
              }
              items.push({ facets: facets, html: node.outerHTML });
            });
            if (page >= EXTRA_MAX_PAGES) {
              finish();
              return;
            }
            fetchPage(page + 1);
          })
          .catch(function (err) {
            console.error('Clothing collection extra-filter dataset fetch failed:', err);
            finish();
          });
      }

      function finish() {
        if (token !== extraLoadToken) return;
        extraCacheKey = key;
        extraCacheItems = items;
        cb(items);
      }

      fetchPage(1);
    }

    function renderExtraFiltered(items) {
      var grid = root.querySelector('[data-product-grid]');
      if (!grid) return;
      var groups = extraGetActiveGroups();

      var matches = items.filter(function (item) {
        return groups.every(function (g) {
          var wanted = extraActive[g];
          var have = item.facets[g] || [];
          return have.some(function (v) { return wanted.has(v); });
        });
      });

      if (!matches.length) {
        grid.innerHTML =
          '<div class="cc-empty" data-empty-state>' +
          '<p>Nothing matches that combination yet.</p>' +
          '<button type="button" class="cc-empty__clear" data-clear-all>Clear filters</button>' +
          '</div>';
        return;
      }

      grid.innerHTML = matches.map(function (m) { return m.html; }).join('');
    }

    function applyExtraFilters() {
      if (!extraHasActive()) {
        restoreOriginalGrid();
        return;
      }
      loadExtraDataset(renderExtraFiltered);
    }

    if (extraFiltersEl) {
      captureOriginalGrid();

      extraFiltersEl.addEventListener('change', function (e) {
        if (!e.target.matches('[data-extra-filter-input]')) return;
        var group = e.target.dataset.extraFilterGroup;
        var value = e.target.value;
        if (!extraActive[group]) extraActive[group] = new Set();
        if (e.target.checked) {
          extraActive[group].add(value);
        } else {
          extraActive[group].delete(value);
        }
        applyExtraFilters();
      });
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clothing-landing-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.cl-hero').forEach(initClothingHero);
  });

  function initClothingHero(root) {
    var track = root.querySelector('[data-hero-track]');
    var dots = root.querySelectorAll('[data-hero-dot]');
    var slides = track ? track.querySelectorAll('.cl-hero__slide') : [];
    if (!track || slides.length < 2) return;

    var autoplay = root.dataset.autoplay === 'true';
    var speed = parseInt(root.dataset.autoplaySpeed, 10) || 6000;
    var timer = null;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function goTo(index) {
      var slide = slides[index];
      if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.heroDot, 10));
        restart();
      });
    });

    track.addEventListener('scroll', function () {
      var index = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    });

    function tick() {
      var index = Math.round(track.scrollLeft / track.clientWidth);
      var next = (index + 1) % slides.length;
      goTo(next);
    }

    function start() {
      if (!autoplay || reduceMotion) return;
      timer = setInterval(tick, speed);
    }

    function restart() {
      clearInterval(timer);
      start();
    }

    track.addEventListener('pointerdown', function () {
      clearInterval(timer);
    });
    track.addEventListener('pointerup', restart);

    start();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clothing-landing-quiz"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.cl-quiz').forEach(initClothingQuiz);
  });

  function initClothingQuiz(root) {
    var answers = {};
    var steps = root.querySelectorAll('[data-quiz-step]');
    var segs = root.querySelectorAll('[data-quiz-seg]');
    var result = root.querySelector('[data-quiz-result]');
    var body = root.querySelector('.cl-quiz__body');

    var rules = [];
    var rulesScript = root.querySelector('[data-quiz-rules]');
    if (rulesScript) {
      try {
        rules = JSON.parse(rulesScript.textContent);
      } catch (e) {
        rules = [];
      }
    }

    function showStep(index) {
      steps.forEach(function (step) {
        step.classList.toggle('is-active', parseInt(step.dataset.quizStep, 10) === index);
      });
      segs.forEach(function (seg) {
        var segIndex = parseInt(seg.dataset.quizSeg, 10);
        seg.classList.toggle('is-active', segIndex === index);
        seg.classList.toggle('is-done', segIndex < index);
      });
    }

    function computeFabric() {
      // Rules are pre-sorted by priority (ascending) at render time; first match wins.
      for (var i = 0; i < rules.length; i++) {
        var rule = rules[i];
        var seasonOk = rule.season === 'any' || rule.season === answers.season;
        var needOk = rule.need === 'any' || rule.need === answers.need;
        if (seasonOk && needOk) return rule.fabric;
      }
      // Fallback if no rules metaobject data is present.
      if (answers.need === 'soft') return 'tender-soft-micro-modal';
      if (answers.need === 'air') return answers.season === 'cool' ? 'pointelle-knit' : 'crinkle-cotton-muslin';
      if (answers.need === 'wear') return 'pointelle-knit';
      return answers.season === 'warm' ? 'crinkle-cotton-muslin' : 'tender-soft-micro-modal';
    }

    function showResult() {
      var key = computeFabric();
      steps.forEach(function (step) {
        step.classList.remove('is-active');
      });
      if (body) body.querySelector('[data-quiz-bar]').hidden = true;
      root.querySelectorAll('[data-fabric-key]').forEach(function (card) {
        card.hidden = card.dataset.fabricKey !== key;
      });
      if (result) result.hidden = false;
    }

    root.addEventListener('click', function (e) {
      var option = e.target.closest('[data-question]');
      if (option) {
        answers[option.dataset.question] = option.dataset.value;
        var currentStep = option.closest('[data-quiz-step]');
        var currentIndex = parseInt(currentStep.dataset.quizStep, 10);
        currentStep.querySelectorAll('[data-question]').forEach(function (opt) {
          opt.classList.remove('is-selected');
        });
        option.classList.add('is-selected');

        setTimeout(function () {
          if (currentIndex < steps.length - 1) {
            showStep(currentIndex + 1);
          } else {
            showResult();
          }
        }, 220);
        return;
      }

      if (e.target.closest('[data-quiz-reset]')) {
        answers = {};
        if (result) result.hidden = true;
        var bar = root.querySelector('[data-quiz-bar]');
        if (bar) bar.hidden = false;
        root.querySelectorAll('[data-question].is-selected').forEach(function (opt) {
          opt.classList.remove('is-selected');
        });
        showStep(0);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clothing-pdp-related-rail"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.cl-pdp-related').forEach(initClothingRelatedRail);
  });

  function initClothingRelatedRail(root) {
    var rail = root.querySelector('[data-rail]');
    var prevBtn = root.querySelector('[data-rail-prev]');
    var nextBtn = root.querySelector('[data-rail-next]');
    var dotsWrap = root.querySelector('[data-rail-dots]');
    var items = root.querySelectorAll('[data-rail-item]');
    if (!rail || !items.length) return;

    function scrollDistance() {
      var first = items[0];
      return first ? first.getBoundingClientRect().width + 18 : 300;
    }

    function updateArrows() {
      if (prevBtn) prevBtn.disabled = rail.scrollLeft <= 2;
      if (nextBtn) nextBtn.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        rail.scrollBy({ left: -scrollDistance(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        rail.scrollBy({ left: scrollDistance(), behavior: 'smooth' });
      });
    }

    if (dotsWrap) {
      var dotCount = Math.min(items.length, 6);
      for (var i = 0; i < dotCount; i++) {
        (function (index) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'cl-pdp-related__dot' + (index === 0 ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
          dot.addEventListener('click', function () {
            var target = items[index];
            if (target) rail.scrollTo({ left: target.offsetLeft - rail.offsetLeft, behavior: 'smooth' });
          });
          dotsWrap.appendChild(dot);
        })(i);
      }

      rail.addEventListener(
        'scroll',
        function () {
          var maxScroll = rail.scrollWidth - rail.clientWidth;
          if (maxScroll <= 0) return;
          var activeIndex = Math.round((rail.scrollLeft / maxScroll) * (dotCount - 1));
          dotsWrap.querySelectorAll('.cl-pdp-related__dot').forEach(function (d, idx) {
            d.classList.toggle('is-active', idx === activeIndex);
          });
        },
        { passive: true }
      );
    }

    rail.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clothing-pdp-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.cl-pdp-tabs').forEach(initClothingPdpTabs);
  });

  function initClothingPdpTabs(root) {
    var triggers = root.querySelectorAll('[data-tab-trigger]');
    var panels = root.querySelectorAll('[data-tab-panel]');
    var barWrap = root.querySelector('[data-tabs-bar-wrap]');

    function setActive(name) {
      triggers.forEach(function (t) {
        var active = t.dataset.tabTrigger === name;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function scrollToPanel(name) {
      var panel = root.querySelector('[data-tab-panel="' + name + '"]');
      if (!panel) return;
      panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setActive(name);
    }

    triggers.forEach(function (t) {
      t.addEventListener('click', function () { scrollToPanel(t.dataset.tabTrigger); });
    });

    document.addEventListener('clothing-pdp:open-tab', function (e) {
      scrollToPanel(e.detail.tab);
    });

    // Scrollspy: highlight the tab whose panel is currently most in view.
    if (window.IntersectionObserver) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              setActive(entry.target.dataset.tabPanel);
            }
          });
        },
        { rootMargin: '-20% 0px -60% 0px', threshold: 0.01 }
      );
      panels.forEach(function (panel) { observer.observe(panel); });
    }

    // Sticky shadow once the tab bar reaches the top of the viewport.
    if (barWrap) {
      var toggleStuck = function () {
        barWrap.classList.toggle('is-stuck', barWrap.getBoundingClientRect().top <= 0);
      };
      window.addEventListener('scroll', toggleStuck, { passive: true });
      toggleStuck();
    }

    root.querySelectorAll('[data-faq-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.closest('.cl-pdp-faq__item').classList.toggle('is-open');
      });
    });

  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clothing-pdp"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-section-type="clothing-pdp"]').forEach(initClothingPdp);
  });

  function initClothingPdp(root) {
    if (root.dataset.pdpInit === 'true') return;
    root.dataset.pdpInit = 'true';

    initGallery(root);
    initStickyBar(root);
    initCartHelpers(root);
  }

  function initGallery(root) {
    var thumbs = root.querySelectorAll('[data-gallery-thumb]');
    var slides = root.querySelectorAll('[data-slide]');
    var stage = root.querySelector('[data-gallery-stage]');
    var prev = root.querySelector('[data-gallery-prev]');
    var next = root.querySelector('[data-gallery-next]');
    var dots = root.querySelectorAll('[data-gallery-dot]');
    var current = 0;

    function show(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      current = index;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
        // Skip when the thumbs row is hidden (mobile) — scrollIntoView on a
        // display:none element is a no-op, and would otherwise be pointless work.
        if (i === index && thumb.offsetParent !== null) {
          thumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(parseInt(dot.dataset.index, 10));
      });
    });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        show(parseInt(thumb.dataset.index, 10));
      });
    });

    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });

    root.querySelectorAll('[data-jump-to-tab]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.dispatchEvent(new CustomEvent('clothing-pdp:open-tab', { detail: { tab: btn.dataset.jumpToTab } }));
      });
    });

    initSwipe(stage, function () { show(current - 1); }, function () { show(current + 1); });
    initZoom(root);
  }

  // Touch-swipe support for the main gallery stage (mobile).
  function initSwipe(stage, onPrev, onNext) {
    if (!stage) return;

    var startX = 0;
    var startY = 0;
    var tracking = false;
    var swiped = false;

    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      tracking = true;
      swiped = false;
    }, { passive: true });

    stage.addEventListener('touchmove', function (e) {
      if (!tracking || e.touches.length !== 1) return;
      var deltaX = e.touches[0].clientX - startX;
      var deltaY = e.touches[0].clientY - startY;
      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 10) {
        swiped = true;
        e.preventDefault();
      }
    }, { passive: false });

    stage.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      if (!swiped) return;

      var deltaX = (e.changedTouches[0].clientX - startX);
      if (Math.abs(deltaX) > 40) {
        if (deltaX > 0) {
          onPrev();
        } else {
          onNext();
        }
      }

      // Suppress the ghost click that follows a touch drag so the zoom
      // lightbox doesn't open right after a swipe.
      e.preventDefault();
    });
  }

  function initZoom(root) {
    var triggers = root.querySelectorAll('[data-gallery-zoom-trigger]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    var lightbox = root.querySelector('[data-gallery-lightbox]');
    if (!triggers.length || !lightbox) return;

    var img = lightbox.querySelector('[data-lightbox-img]');
    var mediaContainer = lightbox.querySelector('[data-lightbox-media]');
    var spinner = lightbox.querySelector('[data-lightbox-spinner]');
    var closeBtn = lightbox.querySelector('[data-lightbox-close]');
    var prevBtn = lightbox.querySelector('[data-lightbox-prev]');
    var nextBtn = lightbox.querySelector('[data-lightbox-next]');

    // One entry per gallery slide (not just per zoom trigger) so stepping
    // through the lightbox with next/prev lands on video/model slides too.
    var items = slides.map(function (slide) {
      var type = slide.dataset.mediaType;
      if (type === 'video' || type === 'external_video' || type === 'model') {
        return { type: type, html: slide.innerHTML };
      }
      var trigger = slide.querySelector('[data-gallery-zoom-trigger]');
      var triggerImg = trigger ? trigger.querySelector('img') : null;
      return {
        type: 'image',
        src: trigger ? trigger.getAttribute('data-photoswipe-src') : '',
        alt: triggerImg ? triggerImg.alt : ''
      };
    });

    var lightboxIndex = 0;

    img.addEventListener('load', function () {
      img.classList.add('is-loaded');
      if (spinner) spinner.classList.remove('is-visible');
    });

    img.addEventListener('error', function () {
      if (spinner) spinner.classList.remove('is-visible');
    });

    function stopMedia() {
      if (!mediaContainer) return;
      var video = mediaContainer.querySelector('video');
      if (video) video.pause();
    }

    function renderLightbox() {
      var item = items[lightboxIndex];
      if (!item) return;

      stopMedia();

      if (item.type !== 'image') {
        if (spinner) spinner.classList.remove('is-visible');
        img.classList.add('is-hidden');
        if (mediaContainer) {
          mediaContainer.innerHTML = item.html;
          mediaContainer.classList.add('is-active');
        }
        return;
      }

      if (mediaContainer) {
        mediaContainer.classList.remove('is-active');
        mediaContainer.innerHTML = '';
      }
      img.classList.remove('is-hidden');

      if (img.src === item.src && img.complete) {
        // Already loaded (e.g. flipping back to a previously viewed image) —
        // the browser won't refire "load" for an unchanged src, so skip
        // straight to the loaded state instead of spinning forever.
        img.classList.add('is-loaded');
        if (spinner) spinner.classList.remove('is-visible');
        return;
      }

      img.classList.remove('is-loaded');
      if (spinner) spinner.classList.add('is-visible');
      img.src = item.src;
      img.alt = item.alt;
    }

    function openLightbox(index) {
      lightboxIndex = index;
      renderLightbox();
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      stopMedia();
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function lightboxPrev() {
      lightboxIndex = lightboxIndex <= 0 ? items.length - 1 : lightboxIndex - 1;
      renderLightbox();
    }

    function lightboxNext() {
      lightboxIndex = lightboxIndex >= items.length - 1 ? 0 : lightboxIndex + 1;
      renderLightbox();
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var slide = trigger.closest('[data-slide]');
        var index = slide ? slides.indexOf(slide) : 0;
        openLightbox(index);
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
    if (prevBtn) prevBtn.addEventListener('click', lightboxPrev);
    if (nextBtn) nextBtn.addEventListener('click', lightboxNext);

    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeLightbox();
    });

    document.addEventListener('keydown', function (e) {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') lightboxPrev();
      if (e.key === 'ArrowRight') lightboxNext();
    });

    initSwipe(lightbox, lightboxPrev, lightboxNext);
  }

  function initStickyBar(root) {
    var bar = root.querySelector('[data-sticky-bar]');
    var anchor = root.querySelector('[data-atc-trigger]') || root.querySelector('.cl-pdp__gallery');
    if (!bar || !anchor) return;

    var stickyVariantTitle = root.querySelector('[data-sticky-variant-title]');
    if (stickyVariantTitle) {
      root.addEventListener('clothing-pdp:variant-change', function (e) {
        var variant = e.detail.variant;
        if (variant) stickyVariantTitle.textContent = variant.title;
      });
    }

    function updateVisibility() {
      if (window.matchMedia('(max-width: 900px)').matches) {
        bar.classList.add('on');
        return;
      }
      var rect = anchor.getBoundingClientRect();
      bar.classList.toggle('on', rect.bottom < 0);
    }

    if (window.IntersectionObserver) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (window.matchMedia('(max-width: 900px)').matches) {
            bar.classList.add('on');
            return;
          }
          bar.classList.toggle('on', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      });
      observer.observe(anchor);
    } else {
      window.addEventListener('scroll', updateVisibility, { passive: true });
    }
    updateVisibility();

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-sticky-atc]')) {
        if (root.dataset.sizeRequired === 'true' && root.dataset.sizeSelected !== 'true') {
          if (window.clothingPdpOpenSizeSheet) window.clothingPdpOpenSizeSheet(root);
          return;
        }
        var mainAtc = root.querySelector('[data-atc-trigger]');
        if (mainAtc) mainAtc.click();
      }
    });
  }
  
  function clothingPdpAddToCartAjax(root, items) {
    var rootPath = root.dataset.rootUrl || '/';
    // Must be the .js (AJAX) endpoint — routes.cart_add_url ("/cart/add") returns
    // a redirect/HTML response, which breaks response.json() below and silently
    // aborts before the cart:open event fires, so the side drawer never opens
    // (even though the item is still added to the cart server-side).
    var cartAddUrl = (root.dataset.cartAddUrl || rootPath + 'cart/add').replace(/(\.js)?$/, '.js');
    return fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Failed to add items to cart.');
        return response.json();
      })
      .then(function (data) {
        return fetch(rootPath + 'cart.js')
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            document.querySelectorAll('.cart-count-bubble, [data-cart-count], .cart-count, #cb').forEach(function (b) {
              if (cart.item_count > 0) {
                b.textContent = cart.item_count;
                b.style.display = 'flex';
              } else {
                b.style.display = 'none';
              }
            });
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: data } }));
            document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));

            if (window.theme && window.theme.CartDrawer) {
              try { new window.theme.CartDrawer(); } catch (e) {}
            }
            clothingPdpToast(root, 'Added to bag successfully!');
            return cart;
          });
      })
      .catch(function (err) {
        console.error('Clothing PDP add-to-cart error:', err);
        clothingPdpToast(root, 'Error adding product(s) to cart.');
      });
  }

  function clothingPdpToast(root, message) {
    var toast = document.querySelector('[data-clothing-pdp-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.setAttribute('data-clothing-pdp-toast', '');
      toast.className = 'cl-pdp-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toast._timeout);
    toast._timeout = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2400);
  }

  function clothingPdpFormatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.theme && window.theme.moneyFormat) {
      return window.Shopify.formatMoney(cents, window.theme.moneyFormat);
    }
    var amount = (cents / 100).toFixed(2);
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'INR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency: currency, minimumFractionDigits: 2 }).format(cents / 100);
    } catch (e) {
      return currency + ' ' + amount;
    }
  }

  function initCartHelpers(root) {
    window.clothingPdpAddToCartAjax = window.clothingPdpAddToCartAjax || clothingPdpAddToCartAjax;
    window.clothingPdpToast = window.clothingPdpToast || clothingPdpToast;
    window.clothingPdpFormatMoney = window.clothingPdpFormatMoney || clothingPdpFormatMoney;
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nrc-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var KEY = 'nrc4_registered';
    function isRegistered() {
      try {
        return localStorage.getItem(KEY) === '1';
      } catch (e) {
        return false;
      }
    }
    function setRegistered() {
      try {
        localStorage.setItem(KEY, '1');
      } catch (e) {}
      document.dispatchEvent(new CustomEvent('nrc:registered'));
    }
    function init(root) {
      var before = root.querySelector('[data-nrc-before-register]');
      var after = root.querySelector('[data-nrc-after-register]');
      var confirmBox = root.querySelector('[data-nrc-confirm]');
      var hint = root.querySelector('[data-nrc-hint]');
      function sync() {
        var done = isRegistered();
        if (before) before.hidden = done;
        if (after) after.hidden = !done;
        if (done && confirmBox) confirmBox.hidden = true;
        if (done && hint) hint.hidden = true;
      }
      var register = root.querySelector('[data-nrc-register]');
      if (register && confirmBox) {
        register.addEventListener('click', function () {
          confirmBox.hidden = false;
        });
      }
      var locked = root.querySelector('[data-nrc-feedback-locked]');
      if (locked && hint) {
        locked.addEventListener('click', function () {
          hint.hidden = false;
        });
      }
      var yes = root.querySelector('[data-nrc-confirm-yes]');
      if (yes) yes.addEventListener('click', setRegistered);
      document.addEventListener('nrc:registered', sync);
      sync();
    }
    function boot() {
      document.querySelectorAll('[data-nrc-hero]').forEach(function (el) {
        if (!el.dataset.nrcReady) {
          el.dataset.nrcReady = '1';
          init(el);
        }
      });
    }
    document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', boot);
    if (document.readyState !== 'loading') boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nrc-results"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boot() {
      var rings = document.querySelectorAll('.nrc-ring:not([data-nrc-ready])');
      rings.forEach(function (ring) {
        ring.dataset.nrcReady = '1';
      });
      if (!('IntersectionObserver' in window)) {
        rings.forEach(function (r) {
          r.classList.add('is-in');
        });
        return;
      }
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              e.target.classList.add('is-in');
              io.unobserve(e.target);
            }
          });
        },
        { threshold: 0.3 }
      );
      rings.forEach(function (r) {
        io.observe(r);
      });
    }
    document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', boot);
    if (document.readyState !== 'loading') boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nrc-spin-reel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var KEY = 'nrc4_registered';
    var SPIN_KEY = 'nrc4_spins';
    var NS = 'http://www.w3.org/2000/svg';

    function read(key, fallback) {
      try {
        var v = localStorage.getItem(key);
        return v ? JSON.parse(v) : fallback;
      } catch (e) {
        return fallback;
      }
    }
    function write(key, value) {
      try {
        localStorage.setItem(key, JSON.stringify(value));
      } catch (e) {}
    }
    function el(name, attrs) {
      var node = document.createElementNS(NS, name);
      Object.keys(attrs || {}).forEach(function (k) {
        node.setAttribute(k, attrs[k]);
      });
      return node;
    }
    function point(angle, r) {
      var a = ((angle - 90) * Math.PI) / 180;
      return [(Math.cos(a) * r).toFixed(2), (Math.sin(a) * r).toFixed(2)];
    }

    function init(root) {
      var wheel = root.querySelector('[data-nrc-wheel]');
      var items = Array.prototype.slice.call(root.querySelectorAll('.nrc-offers__item'));
      if (!wheel || !items.length) return;

      var offers = items.map(function (li) {
        return {
          l1: li.dataset.label1,
          l2: li.dataset.label2,
          color: li.dataset.color || '#fffacd',
          weight: parseFloat(li.dataset.weight) || 1,
          code: li.dataset.code,
          title: li.dataset.title,
          note: li.dataset.note,
          cta: li.dataset.cta,
          url: li.dataset.url
        };
      });
      var n = offers.length;
      var slice = 360 / n;
      var maxSpins = parseInt(root.dataset.spins, 10) || 1;

      wheel.innerHTML = '';
      wheel.appendChild(el('circle', { r: 157, fill: '#5f6825' }));
      offers.forEach(function (o, i) {
        var a = point(i * slice, 150);
        var b = point((i + 1) * slice, 150);
        wheel.appendChild(
          el('path', {
            d: 'M0 0 L' + a[0] + ' ' + a[1] + ' A150 150 0 0 1 ' + b[0] + ' ' + b[1] + ' Z',
            fill: o.color
          })
        );
        var g = el('g', { transform: 'rotate(' + (i * slice + slice / 2) + ')', 'text-anchor': 'middle', fill: '#1a1a1a' });
        var t1 = el('text', { y: -104, 'font-size': n > 6 ? 12 : 15, 'font-weight': 800 });
        t1.textContent = o.l1;
        var t2 = el('text', { y: -87, 'font-size': n > 6 ? 9.5 : 11.5, 'font-weight': 700 });
        t2.textContent = o.l2;
        g.appendChild(t1);
        g.appendChild(t2);
        wheel.appendChild(g);
      });
      offers.forEach(function (o, i) {
        var d = point(i * slice, 150);
        wheel.appendChild(el('circle', { cx: d[0], cy: d[1], r: 4, fill: '#fffacd' }));
      });
      wheel.appendChild(el('circle', { r: 30, fill: '#fff', stroke: '#5f6825', 'stroke-width': 3 }));
      wheel.appendChild(el('circle', { r: 9, fill: '#95a13b' }));

      var btn = root.querySelector('[data-nrc-spin-btn]');
      var veil = root.querySelector('[data-nrc-veil]');
      var prize = root.querySelector('[data-nrc-prize]');
      var spins = read(SPIN_KEY, []);
      var deg = 0;
      var spinning = false;

      function pick() {
        var total = offers.reduce(function (s, o) {
          return s + o.weight;
        }, 0);
        var r = Math.random() * total;
        for (var i = 0; i < offers.length; i++) {
          r -= offers[i].weight;
          if (r <= 0) return i;
        }
        return 0;
      }

      function render() {
        var registered = false;
        try {
          registered = localStorage.getItem(KEY) === '1';
        } catch (e) {}
        if (veil) veil.hidden = registered;
        var last = spins.length ? spins[spins.length - 1] : null;
        var won = last !== null && offers[last] ? offers[last] : null;
        items.forEach(function (li, i) {
          li.classList.toggle('is-won', won !== null && i === last);
        });
        btn.disabled = spinning || spins.length >= maxSpins;
        btn.hidden = spins.length >= maxSpins && !spinning;
        if (won && !spinning) {
          prize.hidden = false;
          prize.querySelector('[data-nrc-prize-title]').textContent = won.title;
          prize.querySelector('[data-nrc-prize-note]').textContent = won.note;
          prize.querySelector('[data-nrc-prize-code]').textContent = won.code;
          var cta = prize.querySelector('[data-nrc-prize-cta]');
          cta.textContent = won.cta;
          cta.href = won.url || '#';
          cta.hidden = !won.cta;
        } else {
          prize.hidden = true;
        }
      }

      btn.addEventListener('click', function () {
        if (spinning || spins.length >= maxSpins) return;
        var idx = pick();
        var center = idx * slice + slice / 2 + (Math.random() - 0.5) * slice * 0.5;
        deg = deg + 1800 + ((((360 - center - (deg % 360)) % 360) + 360) % 360);
        spinning = true;
        render();
        wheel.style.transform = 'rotate(' + deg + 'deg)';
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        setTimeout(function () {
          spinning = false;
          spins.push(idx);
          write(SPIN_KEY, spins);
          render();
        }, reduce ? 50 : 4300);
      });

      var copyBtn = root.querySelector('[data-nrc-copy]');
      if (copyBtn) {
        copyBtn.addEventListener('click', function () {
          var code = prize.querySelector('[data-nrc-prize-code]').textContent;
          if (navigator.clipboard) navigator.clipboard.writeText(code);
        });
      }
      var tagBtn = root.querySelector('[data-nrc-copy-tags]');
      if (tagBtn) {
        tagBtn.addEventListener('click', function () {
          if (navigator.clipboard) navigator.clipboard.writeText(tagBtn.dataset.tags);
        });
      }

      document.addEventListener('nrc:registered', render);
      render();
    }

    function boot() {
      document.querySelectorAll('[data-nrc-spin]').forEach(function (root) {
        if (!root.dataset.nrcReady) {
          root.dataset.nrcReady = '1';
          init(root);
        }
      });
    }
    document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', boot);
    if (document.readyState !== 'loading') boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rfr-build-bundle"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var ICONS = {
      img: '<rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="9" cy="10" r="2"/><path d="M21 17l-5-5-9 8"/>',
      check: '<path d="M5 12l5 5L20 7"/>',
      x: '<path d="M6 6l12 12M18 6L6 18"/>',
      plus: '<path d="M12 5v14M5 12h14"/>'
    };

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function svg(name, size, sw) {
      return '<svg class="rb-icon" viewBox="0 0 24 24" style="width:' + size + 'px;height:' + size + 'px' + (sw ? ';stroke-width:' + sw : '') + '" aria-hidden="true">' + ICONS[name] + '</svg>';
    }
    function numericId(gid) { return String(gid).split('/').pop(); }
    function imgUrl(url, w) {
      if (!url) return '';
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }

    function Bundle(root) {
      var self = this;
      this.root = root;
      this.refs = {};
      root.querySelectorAll('[data-ref]').forEach(function (el) { self.refs[el.getAttribute('data-ref')] = el; });
      this.cfg = {
        apiUrl: root.getAttribute('data-api-url'),
        offerId: root.getAttribute('data-offer-id'),
        cartAddUrl: root.getAttribute('data-cart-add-url'),
        cartUrl: root.getAttribute('data-cart-url'),
        currency: root.getAttribute('data-currency') || 'INR'
      };
      this.offer = null;
      this.tiers = [];
      this.products = [];
      this.cats = ['All'];
      this.state = { sel: [], cat: 'All', q: '' };
      this.busy = false;
      this.toastTimer = null;
      this.lastFocus = null;
      this.bind();
      this.renderTray();
      this.load();
    }

    Bundle.prototype.fmt = function (v) {
      var cur = (this.offer && this.offer.currency) || this.cfg.currency;
      try {
        return new Intl.NumberFormat(cur === 'INR' ? 'en-IN' : undefined, { style: 'currency', currency: cur, maximumFractionDigits: 0 }).format(Math.round(v));
      } catch (e) {
        return Math.round(v).toLocaleString();
      }
    };

    Bundle.prototype.api = function (endpoint, params) {
      var qs = Object.keys(params).map(function (k) { return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]); }).join('&');
      return fetch(this.cfg.apiUrl.replace(/\/$/, '') + '/' + endpoint + '?' + qs, { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(endpoint); return r.json(); });
    };

    Bundle.prototype.load = function () {
      var self = this;
      var id = this.cfg.offerId;
      Promise.all([
        this.api('public', { id: id }),
        this.loadCatalog(id)
      ]).then(function (res) {
        var d = res[0];
        if (!d || !d.ok || !d.offer || !d.offer.isActive) throw new Error('inactive');
        self.offer = d.offer;
        self.tiers = (d.offer.tiers || []).slice().sort(function (a, b) { return a.qty - b.qty; });
        self.buildProducts(res[1]);
        self.setup();
      }).catch(function () { self.fail(); });
    };

    Bundle.prototype.loadCatalog = function (id) {
      var self = this;
      var sections = [];
      function merge(list) {
        (list || []).forEach(function (s) {
          var t = null;
          for (var i = 0; i < sections.length; i++) if (sections[i].title === s.title) t = sections[i];
          if (!t) { t = { title: s.title, products: [] }; sections.push(t); }
          t.products = t.products.concat(s.products || []);
        });
      }
      function page(n) {
        return self.api('products', { id: id, page: n }).then(function (d) {
          if (!d || !d.ok) throw new Error('products');
          merge(d.sections);
          return d.hasMore && n < 20 ? page(n + 1) : sections;
        });
      }
      return page(1);
    };

    Bundle.prototype.buildProducts = function (sections) {
      var self = this;
      var seen = {};
      sections.forEach(function (s) {
        s.products.forEach(function (n) {
          if (seen[n.id]) return;
          seen[n.id] = true;
          var variants = (n.variants || []).map(function (v) {
            return {
              id: numericId(v.id),
              title: v.title,
              available: v.availableForSale,
              price: parseFloat(v.price),
              compare: v.compareAtPrice ? parseFloat(v.compareAtPrice) : 0,
              img: v.image ? v.image.url : ''
            };
          });
          if (!variants.length) return;
          var firstAvail = variants.filter(function (v) { return v.available; })[0];
          self.products.push({
            id: n.id,
            handle: n.handle,
            cat: s.title,
            name: n.title,
            img: n.image ? n.image.url : '',
            variants: variants,
            vid: (firstAvail || variants[0]).id,
            available: n.availableForSale && !!firstAvail
          });
        });
      });
      if (!this.products.length) throw new Error('empty');
      this.cats = ['All'].concat(sections.map(function (s) { return s.title; }).filter(function (c, i, a) { return c && a.indexOf(c) === i; }));
      if (this.cats.length === 2) this.cats = ['All'];
    };

    Bundle.prototype.fail = function () {
      this.refs.grid.innerHTML = '<div class="rb-empty-state"><h3>This offer is not available right now</h3><p>Please check back soon.</p></div>';
      this.refs.pills.innerHTML = '';
      this.refs.tray.hidden = true;
    };

    Bundle.prototype.setup = function () {
      var o = this.offer;
      var banner = this.refs.banner;
      var desktop = o.desktopImageUrl;
      var mobile = o.mobileImageUrl || o.desktopImageUrl;
      if (desktop || mobile) {
        banner.innerHTML = '<picture><source media="(max-width:860px)" srcset="' + esc(mobile || desktop) + '"><img src="' + esc(desktop || mobile) + '" alt="' + esc(o.title) + '"></picture>';
        this.refs.hero.hidden = false;
      }
      var parts = [];
      if (o.startsAt) parts.push('Valid from ' + new Date(o.startsAt).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' }));
      if (o.endsAt) parts.push('until ' + new Date(o.endsAt).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' }));
      if (this.refs.validity) this.refs.validity.textContent = parts.join(' ');
      this.render();
    };

    Bundle.prototype.discountLabel = function (t) {
      return t.discountType === 'percentage' ? t.discountValue + '% off' : this.fmt(t.discountValue) + ' off';
    };

    Bundle.prototype.byId = function (id) {
      for (var i = 0; i < this.products.length; i++) if (this.products[i].id === id) return this.products[i];
      return null;
    };

    Bundle.prototype.variantOf = function (p) {
      for (var i = 0; i < p.variants.length; i++) if (p.variants[i].id === p.vid) return p.variants[i];
      return p.variants[0];
    };

    Bundle.prototype.pricing = function () {
      var self = this;
      var items = this.state.sel.map(function (id) { return self.byId(id); }).filter(Boolean);
      var n = items.length;
      var tier = null;
      this.tiers.forEach(function (t) { if (n >= t.qty) tier = t; });
      var sub = items.reduce(function (a, p) { return a + self.variantOf(p).price; }, 0);
      var save = 0;
      if (tier) {
        save = tier.discountType === 'percentage' ? Math.round(sub * tier.discountValue / 100) : Math.min(sub, tier.discountValue);
      }
      var next = null;
      for (var i = 0; i < this.tiers.length; i++) if (n < this.tiers[i].qty) { next = this.tiers[i]; break; }
      return { items: items, n: n, tier: tier, sub: sub, save: save, pay: sub - save, next: next };
    };

    Bundle.prototype.maxSlots = function () {
      return this.tiers.length ? this.tiers[this.tiers.length - 1].qty : 3;
    };

    Bundle.prototype.message = function (p) {
      if (!this.tiers.length) return '';
      if (p.next) {
        var need = p.next.qty - p.n;
        return (p.tier ? this.discountLabel(p.tier) + ' applied. ' : '') + 'Add ' + need + ' more for ' + this.discountLabel(p.next);
      }
      return 'Best bundle price · ' + this.discountLabel(p.tier) + ' applied';
    };

    Bundle.prototype.toast = function (text) {
      var t = this.refs.toast;
      t.textContent = text;
      t.classList.add('show');
      clearTimeout(this.toastTimer);
      this.toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2600);
    };

    Bundle.prototype.toggle = function (id) {
      var p = this.byId(id);
      if (!p) return;
      var i = this.state.sel.indexOf(id);
      var before = this.pricing().tier;
      if (i > -1) this.state.sel.splice(i, 1);
      else {
        if (!this.variantOf(p).available) { this.toast('This size is out of stock'); return; }
        if (this.state.sel.length >= this.maxSlots()) { this.toast('You can add up to ' + this.maxSlots() + ' products to a bundle'); return; }
        this.state.sel.push(id);
      }
      var after = this.pricing().tier;
      if (after && after !== before) this.toast(this.discountLabel(after) + ' unlocked for your bundle');
      this.render();
    };

    Bundle.prototype.thumb = function (p, cls) {
      var v = this.variantOf(p);
      var src = v.img || p.img;
      return '<div class="' + cls + '">' + (src ? '<img src="' + esc(imgUrl(src, cls === 'rb-card-img' ? 600 : 160)) + '" alt="" loading="lazy">' : svg('img', cls === 'rb-card-img' ? 40 : 20, 1.3)) + '</div>';
    };

    Bundle.prototype.renderPills = function () {
      var self = this;
      this.refs.pills.hidden = this.cats.length < 2;
      this.refs.pills.innerHTML = this.cats.map(function (c) {
        return '<button type="button" class="rb-pill" data-cat="' + esc(c) + '" aria-pressed="' + (c === self.state.cat) + '">' + esc(c) + '</button>';
      }).join('');
    };

    Bundle.prototype.renderGrid = function () {
      var self = this;
      var q = this.state.q.trim().toLowerCase();
      var terms = q ? q.split(/\s+/) : [];
      var list = this.products.filter(function (p) {
        if (self.state.cat !== 'All' && p.cat !== self.state.cat) return false;
        var hay = (p.name + ' ' + p.cat).toLowerCase();
        return terms.every(function (t) { return hay.indexOf(t) > -1; });
      });
      this.refs.count.textContent = list.length + (list.length === 1 ? ' product' : ' products');
      if (!list.length) {
        this.refs.grid.innerHTML = '<div class="rb-empty-state"><h3>No products match “' + esc(this.state.q.trim()) + '”' + (this.state.cat !== 'All' ? ' in ' + esc(this.state.cat) : '') + '</h3>' +
          '<p>Try another word, or clear the search to see everything.</p>' +
          '<button type="button" class="rb-pill" data-reset-search>Clear search' + (this.state.cat !== 'All' ? ' and filters' : '') + '</button></div>';
        return;
      }
      this.refs.grid.innerHTML = list.map(function (p) {
        var on = self.state.sel.indexOf(p.id) > -1;
        var v = self.variantOf(p);
        var out = !v.available;
        var full = !on && self.state.sel.length >= self.maxSlots();
        var select = '';
        if (p.variants.length > 1) {
          select = '<select class="rb-variant" data-variant="' + esc(p.id) + '" aria-label="Choose option for ' + esc(p.name) + '">' +
            p.variants.map(function (x) {
              return '<option value="' + esc(x.id) + '"' + (x.id === v.id ? ' selected' : '') + (x.available ? '' : ' disabled') + '>' + esc(x.title) + (x.available ? '' : ' (sold out)') + '</option>';
            }).join('') + '</select>';
        }
        return '<article class="rb-card' + (on ? ' is-on' : '') + (out ? ' is-out' : '') + '">' +
          '<div class="rb-card-media">' + self.thumb(p, 'rb-card-img') +
            '<span class="rb-badge">' + svg('check', 14, 2.2) + '<span>In your bundle</span></span></div>' +
          '<div class="rb-card-body">' +
            (p.cat ? '<p class="rb-card-cat">' + esc(p.cat) + '</p>' : '') +
            '<h3 class="rb-card-name"><a href="/products/' + esc(p.handle) + '" target="_blank" rel="noopener">' + esc(p.name) + '</a></h3>' +
            select +
            '<p class="rb-card-price"><span>' + self.fmt(v.price) + '</span>' + (v.compare > v.price ? '<s>' + self.fmt(v.compare) + '</s>' : '') + '</p>' +
            '<button type="button" class="rb-add-btn" data-toggle="' + esc(p.id) + '" aria-pressed="' + on + '"' + ((out || full) && !on ? ' disabled' : '') + '>' + (on ? 'Remove from bundle' : (out ? 'Sold out' : (full ? 'Bundle full' : 'Add to bundle'))) + '</button>' +
          '</div></article>';
      }).join('');
    };

    Bundle.prototype.trayInner = function (p, isSheet) {
      var self = this;
      var slots = p.items.map(function (it) {
        var v = self.variantOf(it);
        return '<li class="rb-slot">' + self.thumb(it, 'rb-thumb') +
          '<div class="rb-slot-info"><p class="rb-slot-name">' + esc(it.name) + '</p>' +
          '<p class="rb-slot-meta">' + (it.variants.length > 1 ? esc(v.title) + ' · ' : '') + self.fmt(v.price) + '</p></div>' +
          '<button type="button" class="rb-rm-btn" data-toggle="' + esc(it.id) + '" aria-label="Remove ' + esc(it.name) + '">' + svg('x', 16, 1.8) + '</button></li>';
      }).join('');
      var max = this.maxSlots();
      for (var i = p.n; i < max; i++) {
        var tier = null;
        for (var t = 0; t < this.tiers.length; t++) if (this.tiers[t].qty === i + 1) tier = this.tiers[t];
        var label = i === 0 ? 'Pick your first product' : (tier ? 'Pick 1 more for ' + this.discountLabel(tier) : 'Pick another product');
        slots += '<li class="rb-slot empty"><div class="rb-thumb">' + svg('plus', 20, 1.6) + '</div>' + esc(label) + '</li>';
      }
      var width = Math.min(p.n, max) / max * 100;
      var minQty = this.tiers.length ? this.tiers[0].qty : 1;
      var ready = p.n >= minQty;
      return (isSheet ? '<div class="rb-grabber"></div>' : '') +
        '<div class="rb-tray-head"><h2>Your bundle</h2>' +
          (isSheet ? '<button type="button" class="rb-icon-btn" data-close aria-label="Close" style="margin-right:-10px">' + svg('x', 20, 1.8) + '</button>'
                   : (p.n ? '<button type="button" class="rb-link-btn" data-clear>Clear all</button>' : '')) +
        '</div>' +
        (isSheet ? '' : '<div><div class="rb-progress"><i style="width:' + width + '%"></i></div>' +
          '<div class="rb-marks">' + this.tiers.map(function (t) { return '<span>Buy ' + t.qty + ' · ' + esc(self.discountLabel(t)) + '</span>'; }).join('') + '</div></div>') +
        '<p class="rb-msg" role="status">' + esc(this.message(p)) + '</p>' +
        '<ul class="rb-slots">' + slots + '</ul>' +
        '<dl class="rb-summary">' +
          '<div><dt>Selling price (' + p.n + (p.n === 1 ? ' item' : ' items') + ')</dt><dd>' + this.fmt(p.sub) + '</dd></div>' +
          '<div><dt>Bundle offer' + (p.tier ? ' (' + esc(this.discountLabel(p.tier)) + ')' : '') + '</dt><dd class="rb-save">' + (p.save ? '−' + this.fmt(p.save) : this.fmt(0)) + '</dd></div>' +
          '<div class="rb-total"><dt>Bundle price</dt><dd>' + this.fmt(p.pay) + '</dd></div>' +
        '</dl>' +
        '<button type="button" class="rb-cta" data-checkout' + (!ready || this.busy ? ' disabled' : '') + '>' +
          (this.busy ? 'Adding…' : (ready ? 'Add bundle to bag · ' + this.fmt(p.pay) : 'Pick ' + (minQty - p.n) + ' more to continue')) + '</button>' +
        (isSheet ? '' : '<p class="rb-fine">Offer is applied automatically in your bag.</p>');
    };

    Bundle.prototype.renderTray = function () {
      var p = this.pricing();
      this.refs.tray.innerHTML = this.trayInner(p, false);
      this.refs.sheet.innerHTML = this.trayInner(p, true);
      var max = this.maxSlots();
      var w = Math.min(p.n, max) / max * 100;
      this.root.querySelectorAll('[data-progress]').forEach(function (el) { el.style.width = w + '%'; });
      this.refs.mCount.textContent = p.n + ' of ' + max;
      this.refs.mMsg.textContent = this.message(p);
      this.refs.mPay.textContent = this.fmt(p.pay);
      this.refs.mSave.textContent = p.save ? 'You save ' + this.fmt(p.save) : 'Bundle price';
      this.refs.openSheet.textContent = 'View bundle (' + p.n + ')';
    };

    Bundle.prototype.render = function () {
      this.renderPills();
      this.renderGrid();
      this.renderTray();
    };

    Bundle.prototype.openSheet = function () {
      this.lastFocus = document.activeElement;
      this.refs.sheetWrap.classList.add('open');
      document.body.style.overflow = 'hidden';
      var f = this.refs.sheet.querySelector('button');
      if (f) f.focus();
    };

    Bundle.prototype.closeSheet = function () {
      this.refs.sheetWrap.classList.remove('open');
      document.body.style.overflow = '';
      if (this.lastFocus) this.lastFocus.focus();
    };

    Bundle.prototype.checkout = function () {
      var self = this;
      var p = this.pricing();
      var minQty = this.tiers.length ? this.tiers[0].qty : 1;
      if (p.n < minQty || this.busy) return;
      this.busy = true;
      this.renderTray();
      var items = p.items.map(function (it) {
        return { id: Number(self.variantOf(it).id), quantity: 1, properties: { _mixmatch_offer: String(self.offer.id) } };
      });
      fetch(this.cfg.cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || 'Could not add the bundle to your bag');
          return j;
        });
      }).then(function () {
        self.toast('Bundle added to bag');
        window.location.href = self.cfg.cartUrl;
      }).catch(function (e) {
        self.busy = false;
        self.renderTray();
        self.toast(e.message || 'Could not add the bundle to your bag');
      });
    };

    Bundle.prototype.setQuery = function (v) {
      this.state.q = v;
      this.refs.q.value = v;
      this.refs.searchForm.classList.toggle('has-q', !!v);
      this.renderGrid();
    };

    Bundle.prototype.bind = function () {
      var self = this;
      this.root.addEventListener('click', function (e) {
        var t = e.target.closest('[data-toggle],[data-cat],[data-clear],[data-close],[data-checkout],[data-reset-search]');
        if (t) {
          if (t.hasAttribute('data-toggle')) self.toggle(t.getAttribute('data-toggle'));
          else if (t.hasAttribute('data-cat')) { self.state.cat = t.getAttribute('data-cat'); self.renderPills(); self.renderGrid(); }
          else if (t.hasAttribute('data-clear')) { self.state.sel = []; self.render(); }
          else if (t.hasAttribute('data-close')) self.closeSheet();
          else if (t.hasAttribute('data-checkout')) self.checkout();
          else if (t.hasAttribute('data-reset-search')) { self.state.cat = 'All'; self.setQuery(''); self.renderPills(); self.refs.q.focus(); }
          return;
        }
        if (e.target.closest('[data-ref="qClear"]')) { self.setQuery(''); self.refs.q.focus(); }
        else if (e.target.closest('[data-ref="openSheet"]')) self.openSheet();
      });
      this.root.addEventListener('change', function (e) {
        var sel = e.target.closest('[data-variant]');
        if (!sel) return;
        var p = self.byId(sel.getAttribute('data-variant'));
        if (!p) return;
        p.vid = sel.value;
        if (!self.variantOf(p).available) {
          var i = self.state.sel.indexOf(p.id);
          if (i > -1) self.state.sel.splice(i, 1);
        }
        self.render();
      });
      this.refs.q.addEventListener('input', function (e) { self.setQuery(e.target.value); });
      this.refs.searchForm.addEventListener('submit', function (e) { e.preventDefault(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.refs.sheetWrap.classList.contains('open')) self.closeSheet();
      });
    };

    function init(scope) {
      (scope || document).querySelectorAll('[data-rfr-bundle]').forEach(function (el) {
        if (el.__rfrBundle) return;
        el.__rfrBundle = new Bundle(el);
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rfr-fabric-test-reports"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.addEventListener('DOMContentLoaded', function(){
    var root = document.getElementById('rfr-test-reports');
    if(!root) return;

    /* ---------- banner carousel ---------- */
    var bnEl = root.querySelector('[data-banner]');
    if(bnEl){
      var track = bnEl.querySelector('[data-track]');
      var slides = track ? Array.prototype.slice.call(track.children) : [];
      var dots = bnEl.querySelectorAll('[data-bndot]');
      var autoplay = parseInt(bnEl.dataset.autoplay, 10) || 0;
      var i = 0, timer = null;

      function go(n){
        if(!slides.length) return;
        i = (n + slides.length) % slides.length;
        track.style.transform = 'translateX(' + (-i * 100) + '%)';
        for(var k = 0; k < dots.length; k++) dots[k].classList.toggle('is-on', k === i);
      }
      function play(){
        if(!autoplay || slides.length < 2) return;
        stop();
        timer = setInterval(function(){ go(i + 1); }, autoplay);
      }
      function stop(){ if(timer){ clearInterval(timer); timer = null; } }

      if(slides.length > 1){
        bnEl.addEventListener('click', function(e){
          var nav = e.target.closest('[data-bn]');
          if(nav){ e.preventDefault(); go(i + (+nav.dataset.bn)); play(); return; }
          var dot = e.target.closest('[data-bndot]');
          if(dot){ go(+dot.dataset.bndot); play(); }
        });
        bnEl.addEventListener('mouseenter', stop);
        bnEl.addEventListener('mouseleave', play);
        bnEl.addEventListener('focusin', stop);

        var x0 = null;
        bnEl.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; stop(); }, {passive:true});
        bnEl.addEventListener('touchend', function(e){
          if(x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if(Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1));
          x0 = null; play();
        }, {passive:true});

        play();
      }
    }

    /* ---------- accordion ---------- */
    var accEl = root.querySelector('[data-acc]');
    var toggleAll = root.querySelector('[data-toggle-all]');

    accEl.addEventListener('click', function(e){
      var btn = e.target.closest('.rfr-fab__btn');
      if(!btn) return;
      var fab = btn.closest('.rfr-fab');
      var open = fab.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      syncToggleAll();
    });

    function syncToggleAll(){
      if(!toggleAll) return;
      var fabs = Array.prototype.slice.call(accEl.querySelectorAll('.rfr-fab'));
      var allOpen = fabs.length > 0 && fabs.every(function(f){ return f.classList.contains('is-open'); });
      toggleAll.textContent = allOpen ? 'Collapse all' : 'Expand all';
      toggleAll.dataset.state = allOpen ? 'open' : 'closed';
    }

    if(toggleAll){
      toggleAll.addEventListener('click', function(){
        var open = toggleAll.dataset.state !== 'open';
        accEl.querySelectorAll('.rfr-fab').forEach(function(fab){
          fab.classList.toggle('is-open', open);
          fab.querySelector('.rfr-fab__btn').setAttribute('aria-expanded', open ? 'true' : 'false');
        });
        syncToggleAll();
      });
    }

    syncToggleAll();

    /* ---------- style detail drawer ---------- */
    var drawer = root.querySelector('[data-drawer]');
    var drawerB = root.querySelector('[data-drawer-body]');
    var lastFocus = null;

    function openDrawer(card){
      var tpl = card.parentElement.querySelector('[data-drawer-tpl]');
      if(!tpl || !drawer || !drawerB) return;
      drawerB.innerHTML = '';
      drawerB.appendChild(tpl.content.cloneNode(true));
      lastFocus = document.activeElement;
      drawer.hidden = false;
      document.body.style.overflow = 'hidden';
      var x = drawer.querySelector('.rfr-drawer__x');
      if(x) x.focus();
    }
    function closeDrawer(){
      if(!drawer) return;
      drawer.hidden = true;
      document.body.style.overflow = '';
      if(lastFocus && lastFocus.focus) lastFocus.focus();
    }

    accEl.addEventListener('click', function(e){
      var card = e.target.closest('[data-drawer-open]');
      if(card) openDrawer(card);
    });
    if(drawer){
      drawer.querySelectorAll('[data-drawer-close]').forEach(function(el){
        el.addEventListener('click', closeDrawer);
      });
      document.addEventListener('keydown', function(e){
        if(e.key === 'Escape' && !drawer.hidden) closeDrawer();
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rfr-media-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MOBILE = window.matchMedia('(max-width: 749px)');
    var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

    function saveData() {
      var c = navigator.connection;
      return !!(c && c.saveData);
    }

    function MediaSlider(root) {
      if (root.__msInit) return;
      root.__msInit = true;

      var track = root.querySelector('.ms-slider__track');
      var prev = root.querySelector('.ms-slider__nav--prev');
      var next = root.querySelector('.ms-slider__nav--next');
      var cards = Array.prototype.slice.call(root.querySelectorAll('.ms-card--video'));
      var autoplayMobile = root.getAttribute('data-autoplay-mobile') === 'true';
      var autoplayDesktop = root.getAttribute('data-autoplay-desktop') === 'true';
      var soundOn = false; // starts muted; one choice shared by every video
      var atStart = true; // until the visitor or the timer moves the slider, the first video is the one that plays
      var chosen = null; // desktop: card the visitor started by hand
      var inView = true;
      var scrollTimer;

      /* ---------- arrows ---------- */
      function updateNav() {
        if (!prev || !next) return;
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.hidden = track.scrollLeft <= 2;
        next.hidden = track.scrollLeft >= max;
      }

      function scrollByPage(dir) {
        track.scrollBy({
          left: dir * track.clientWidth * 0.85,
          behavior: REDUCED.matches ? 'auto' : 'smooth'
        });
      }

      if (prev) prev.addEventListener('click', function () { atStart = false; scrollByPage(-1); });
      if (next) next.addEventListener('click', function () { atStart = false; scrollByPage(1); });

      /* ---------- banner click tracking (same event as the slideshow) ---------- */
      window.dataLayer = window.dataLayer || [];
      track.addEventListener('click', function (e) {
        var link = e.target.closest && e.target.closest('.ms-card__link');
        if (!link || !track.contains(link)) return;
        var card = link.closest('.ms-card');
        window.dataLayer.push({
          event: 'banner_click',
          promotion_name: link.getAttribute('href') || '',
          promotion_id: card ? card.getAttribute('data-index') || '' : '',
          creative_name: 'Media slider'
        });
      });

      /* ---------- video ---------- */
      function play(card) {
        var video = card.querySelector('.ms-card__video');
        if (!video) return;
        if (!video.getAttribute('src')) {
          // Lazy: the file is only requested the first time it's played.
          video.src = video.getAttribute('data-src');
          video.preload = 'auto';
          card.classList.add('is-loading');
          video.load();
        }
        video.muted = !soundOn;
        var p = video.play();
        if (p && p.catch) {
          p.catch(function () {
            if (soundOn) {
              // Browser refused sound without a gesture: retry muted.
              soundOn = false;
              applySound();
              var retry = video.play();
              if (retry && retry.catch) retry.catch(function () { card.classList.remove('is-loading'); });
              return;
            }
            card.classList.remove('is-loading');
          });
        }
      }

      function applySound() {
        cards.forEach(function (card) {
          var video = card.querySelector('.ms-card__video');
          var snd = card.querySelector('.ms-card__sound');
          video.muted = !soundOn;
          snd.setAttribute('aria-pressed', soundOn ? 'true' : 'false');
          snd.setAttribute('aria-label', soundOn ? 'Mute video' : 'Unmute video');
        });
      }

      function pause(card) {
        var video = card.querySelector('.ms-card__video');
        if (video && !video.paused) video.pause();
      }

      cards.forEach(function (card) {
        var video = card.querySelector('.ms-card__video');
        var btn = card.querySelector('.ms-card__btn');
        var snd = card.querySelector('.ms-card__sound');

        snd.addEventListener('click', function () {
          soundOn = !soundOn;
          applySound();
          if (soundOn && video.paused && !card.__manualPause) play(card);
        });

        video.addEventListener('playing', function () {
          card.classList.remove('is-loading');
          card.classList.add('is-playing', 'is-started');
          btn.setAttribute('aria-label', 'Pause video');
        });
        video.addEventListener('pause', function () {
          card.classList.remove('is-playing');
          btn.setAttribute('aria-label', 'Play video');
        });
        video.addEventListener('error', function () {
          card.classList.remove('is-loading');
        });

        btn.addEventListener('click', function () {
          if (video.paused) {
            card.__manualPause = false;
            chosen = card;
            atStart = false;
            // Only one video at a time.
            cards.forEach(function (c) { if (c !== card) pause(c); });
            play(card);
          } else {
            card.__manualPause = true;
            pause(card);
          }
        });

        card.addEventListener('touchstart', function () {
          card.classList.add('is-touch');
        }, { passive: true, once: true });
      });

      /* ---------- mobile: autoplay the centred slide ---------- */
      function centredCard() {
        var mid = track.getBoundingClientRect().left + track.clientWidth / 2;
        var best = null;
        var bestDist = Infinity;
        Array.prototype.forEach.call(track.children, function (li) {
          var r = li.getBoundingClientRect();
          var d = Math.abs(r.left + r.width / 2 - mid);
          if (d < bestDist) { bestDist = d; best = li; }
        });
        return best;
      }

      // Desktop: the visitor's own pick if still on screen, else the first video fully in view.
      function visibleCard() {
        var box = track.getBoundingClientRect();
        function visible(card) {
          var r = card.getBoundingClientRect();
          return r.left >= box.left - 4 && r.right <= box.right + 4;
        }
        if (chosen && visible(chosen)) return chosen;
        chosen = null;
        for (var i = 0; i < cards.length; i++) {
          if (visible(cards[i])) return cards[i];
        }
        return null;
      }

      function syncCentred() {
        var mobile = MOBILE.matches;
        if (!(mobile ? autoplayMobile : autoplayDesktop)) return;
        var target = null;
        if (inView) target = atStart ? cards[0] : (mobile ? centredCard() : visibleCard());
        cards.forEach(function (card) {
          if (card === target) {
            if (!card.__manualPause && !REDUCED.matches && !saveData()) play(card);
          } else {
            card.__manualPause = false; // a new visit to this slide autoplays again
            pause(card);
          }
        });
      }

      track.addEventListener('scroll', function () {
        updateNav();
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(syncCentred, 120);
      }, { passive: true });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          inView = entries[0].isIntersecting;
          if (!inView) cards.forEach(pause);
          syncCentred();
        }, { threshold: 0.4 }).observe(root);
      }

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) cards.forEach(pause);
        else syncCentred();
      });

      if (MOBILE.addEventListener) {
        MOBILE.addEventListener('change', function () {
          cards.forEach(pause);
          syncCentred();
        });
      }

      /* ---------- mobile: move to the next slide on a timer ---------- */
      var autorotate = root.getAttribute('data-autorotate-mobile') === 'true';
      var rotateMs = (parseInt(root.getAttribute('data-autorotate-seconds'), 10) || 4) * 1000;
      var rotateTimer;
      var resumeTimer;
      var userActive = false;
      var videoTicks = 0;

      function anyVideoPlaying() {
        return cards.some(function (card) { return card.classList.contains('is-playing'); });
      }

      function rotateNext() {
        atStart = false;
        var slides = Array.prototype.slice.call(track.children);
        if (slides.length < 2) return;
        var current = slides.indexOf(centredCard());
        var target = slides[current + 1 >= slides.length ? 0 : current + 1];
        track.scrollTo({
          left: target.offsetLeft - (track.clientWidth - target.offsetWidth) / 2,
          behavior: 'smooth'
        });
      }

      function scheduleRotate() {
        clearTimeout(rotateTimer);
        if (!autorotate || !MOBILE.matches || REDUCED.matches) return;
        rotateTimer = setTimeout(function () {
          if (inView && !document.hidden && !userActive) {
            // Let a playing video run, but never hold the banner for more than ~3 ticks.
            if (anyVideoPlaying() && videoTicks < 3) {
              videoTicks += 1;
            } else {
              videoTicks = 0;
              rotateNext();
            }
          }
          scheduleRotate();
        }, rotateMs);
      }

      function holdRotation() {
        atStart = false;
        userActive = true;
        clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function () { userActive = false; }, 6000);
      }

      ['touchstart', 'pointerdown', 'wheel'].forEach(function (name) {
        track.addEventListener(name, holdRotation, { passive: true });
      });

      if (MOBILE.addEventListener) {
        MOBILE.addEventListener('change', scheduleRotate);
      }

      window.addEventListener('resize', updateNav);
      applySound();
      updateNav();
      syncCentred();
      scheduleRotate();
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.ms-slider').forEach(MediaSlider);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
